/**
 * Validation of the manual coordinates an Agency Supervisor types into the
 * Deliveries tab: they must be decimal numbers within the valid latitude/longitude
 * range. Whether the pin is inside the country is the server's call: it refuses
 * a pin outside the country's box (DeliveryOutOfCountry) and flags such rows
 * with `outOfCountry`, so the boxes are not copied here.
 */
export type CoordinatesConversion =
  | { ok: true; latitude: number; longitude: number }
  | { ok: false; message: string };

const parseCoordinate = (value: string) => {
  const trimmed = value.trim();
  return /^-?\d+(\.\d+)?$/.test(trimmed) ? Number(trimmed) : Number.NaN;
};

export function parseDeliveryCoordinates(
  latitudeDraft: string,
  longitudeDraft: string,
): CoordinatesConversion {
  const latitude = parseCoordinate(latitudeDraft);
  const longitude = parseCoordinate(longitudeDraft);

  if (Number.isNaN(latitude) || Number.isNaN(longitude)) {
    return {
      ok: false,
      message: 'Latitude and longitude must be decimal numbers.',
    };
  }
  if (latitude < -90 || latitude > 90 || longitude < -180 || longitude > 180) {
    return { ok: false, message: 'The coordinates are out of range.' };
  }

  return { ok: true, latitude, longitude };
}
